<template>
    <div>
        <b-navbar toggleable="md" fixed="top">
            <b-navbar-brand href="#">
                <router-link :to="{ name: 'home' }">
                    <b-img class="mx-2" width='210px' fluid
                        :src="require('../assets/img/logo1.png')">
                    </b-img>
                </router-link>
            </b-navbar-brand>            
            <b-navbar-toggle target="nav_menu"></b-navbar-toggle>

            <b-collapse id="nav_menu" is-nav>
            <!-- Menu -->
                <!-- <b-navbar-nav class="col-9" v-if="logueado">  -->
                <b-navbar-nav class="mr-auto flex-wrap">
                    <b-nav-item v-if="logueado" :to="{name: 'expedientes'}" exact>
                        <b-button size="sm" variant="outline-secondary">Expedientes</b-button>
                    </b-nav-item>
                    <b-nav-item v-if="logueado" :to="{name: 'proveedores'}" exact>
                        <b-button size="sm" variant="outline-secondary">Proveedores</b-button>
                    </b-nav-item>

                    <!-- <b-nav-item v-if="logueado" :to="{name: 'grid'}">Grid</b-nav-item>
                    <b-nav-item v-if="logueado" :to="{name: 'reservas'}">Reservas</b-nav-item> -->

                </b-navbar-nav>

            <!-- Acceso -->
                <b-navbar-nav class="align-items-center">
                    <div v-if="logueado" class="pr-2">{{ this.usuario }}</div>
                    <b-avatar button variant="primary" @click="acceso"></b-avatar>

                </b-navbar-nav>
            </b-collapse> 
        </b-navbar>       
    </div>
</template>

<script>

export default {
    name: 'AppMenu',
    components: {
        
    },
    data: () => ({
        //titulo: 'PAGINA WEB',    
    }),
    computed: {
        logueado() {
            return this.$store.state.auth.logueado;
        },
        usuario() {
            return this.$store.state.auth.user.usu;
        },
        tit() {
            //return "hola";
            return this.$store.state.G.pagina;
        }        

    },
    methods: {
        acceso() {
            if (this.logueado) this.desconectar();
        },

        login() { 
            //this.$root.$emit('modal','modal_login');
            this.$bvModal.show("modal_login");
        },
        registro() { 
            this.$bvModal.show("modal_registro");
        },

        desconectar() {
            //alert('La sesion se ha desconectado ...');
            this.$store.commit('modal',{tit:"Desconectar",msg:"Se ha desconectado de la Sesion"});
            this.$store.commit('login_off');    
            this.$router.push('/');
        },
        openAlerta() {        
        
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete everything.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'ACEPTAR',
                cancelTitle: 'CANCELAR',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                //this.boxTwo = value
                console.log(value);
            })
            .catch(error => {
                // An error occurred
                console.log(error)
            })
        }
    },
    
}
</script>